import service from '@/api/newsletter';
import {handleError} from '@/state/generators/helpers';
import {alert, loading} from "../generators/helpers";

export const state = {
    previewLoading: false,
    preview: '',
    service: service('newsletters/newsletters'),
    testLoading: false,
    statistic: {},
    statisticLoading: false,
    forCopy: {},
}

export const getters = {
    previewLoading: function (state) {
        return !!state.previewLoading
    },
    preview: function (state) {
        return state.preview;
    },
    statisticLoading: function (state) {
        return !!state.statisticLoading
    },
    statistic: function (state) {
        return state.statistic;
    },
    forCopy: function (state) {
        return JSON.parse(JSON.stringify(state.forCopy));
    },
}

export const mutations = {
    'SET_PREVIEW': function (state, str = '') {
        state.preview = str;
    },

    'SET_PREVIEW_LOADING': function (state, boolean = true) {
        state.previewLoading = boolean;
    },

    'SET_STATISTIC': function (state, obj = {}) {
        state.statistic = obj;
    },

    'SET_STATISTIC_LOADING': function (state, boolean = true) {
        state.statisticLoading = boolean;
    },

    'SET_TEST_LOADING': function (state, boolean = true) {
        state.testLoading = boolean;
    },

    'SET_FOR_COPY': function (state, item = {}) {
        state.forCopy = item;
    }
}

export const actions = {
    preview: function ({commit, state}, {id, query}) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_PREVIEW_LOADING', true);

        return state.service.preview(id, query).then(response => {
            commit('SET_PREVIEW', response);
            commit('app/SET_LOADING', false, {root: true});
            commit('SET_PREVIEW_LOADING', false);
            const blob = new Blob([response], { type: 'text/html' });
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        })
    },

    approve: function ({commit, state}, {id, query}) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_LOADING', true);

        return state.service.approve(id, query).then(response => {
            const model = Object.assign({}, response.data)

            commit('REPLACE_ITEM', model);
            commit('SET_ITEM', model);
            alert(commit, this.$t('request.save_is_successful'))
            commit('SET_ERRORS', {});

            commit('app/SET_LOADING', false, {root: true});
            commit('SET_LOADING', false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        })
    },

    withdrawApproval: function ({commit, state}, {id, query}) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_LOADING', true);

        return state.service.withdrawApproval(id, query).then(response => {
            const model = Object.assign({}, response.data)

            commit('REPLACE_ITEM', model);
            commit('SET_ITEM', model);
            alert(commit, this.$t('request.save_is_successful'))
            commit('SET_ERRORS', {});

            commit('app/SET_LOADING', false, {root: true});
            commit('SET_LOADING', false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        })
    },

    cancel: function ({commit, state}, {id, query}) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_LOADING', true);

        return state.service.cancel(id, query).then(response => {
            const model = Object.assign({}, response.data)

            commit('REPLACE_ITEM', model);
            commit('SET_ITEM', model);
            alert(commit, this.$t('request.save_is_successful'))
            commit('SET_ERRORS', {});

            commit('app/SET_LOADING', false, {root: true});
            commit('SET_LOADING', false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        })
    },

    continueSending: function ({commit, state}, {id, query}) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_LOADING', true);

        return state.service.continueSending(id, query).then(response => {
            const model = Object.assign({}, response.data)

            commit('REPLACE_ITEM', model);
            commit('SET_ITEM', model);
            alert(commit, this.$t('request.save_is_successful'))
            commit('SET_ERRORS', {});

            commit('app/SET_LOADING', false, {root: true});
            commit('SET_LOADING', false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        })
    },

    test: function ({commit, state}, {id, data}) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_TEST_LOADING', true);

        return state.service.test(id, data).then(response => {
            commit('app/SET_LOADING', false, {root: true});
            commit('SET_TEST_LOADING', false);
            alert(commit, response.message);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        })
    },

    statistic: function ({commit, state}, {id, data}) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_STATISTIC_LOADING', true);

        return state.service.statistic(id, data).then(response => {
            commit('app/SET_LOADING', false, {root: true});
            commit('SET_STATISTIC_LOADING', false);
            commit('SET_STATISTIC', response.data);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        })
    },

    copy: function ({commit, state, /*dispatch*/}, payload) {
        loading(commit)

        return state.service.store(payload).then(data => {
            const model = Object.assign({}, payload, data.data);

            alert(commit, this.$t('request.creation_is_successful'));
            commit('SET_ERRORS', {});
            // dispatch('all', state.allQuery);

            loading(commit, false);

            return model;
        }).catch((e) => {
            handleError(e, commit)
        })
    },


    forCopy: function ({commit, state}, {id, query}) {
        loading(commit)

        return state.service.fetchItemForCopy(id, query).then(data => {
            commit('SET_FOR_COPY', data.data);
            loading(commit, false);
            return data;
        }).catch((e) => {
            handleError(e, commit);
        })
    },

    clearForCopy: function ({commit}) {
        commit('SET_FOR_COPY', {});
    },
}
